import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/organisms';
import { HomePage, ProductsPage } from './pages';
import './App.css';

function AppContent() {
  const location = useLocation();

  const handleLinkClick = (link) => {
    console.log('Link clicked:', link);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar
        logo="Pharma Outlet"
        logoTo="/"
        activePath={location.pathname}
        onLinkClick={handleLinkClick}
      />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
